module.exports = __webpack_public_path__ + "static/img/meizuNote6.f39656b0.png";